import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_marrua.png",
      alt: "Marrua Gestora",
    },
    title: "Mais resultado, maior liberdade. ",

    // String ou array de strings
    text: [
      "Oferecemos estratégias quantitativas de alto desempenho, desenvolvidas por especialistas com décadas de experiência em day trading. Nossos robôs proporcionam aos investidores individuais liberdade, eficiência e resultados consistentes, livres de vieses emocionais. Escolha Marrua para uma jornada de investimento mais inteligente e tranquila. ",
    ],
    testimonial: {
      text: "Deixe nossos algoritmos trabalharem enquanto você vive.",
      author: {
        name: "Matheus Rodrigues, CEO da Marrua",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Algoritmos Marrua Quant",
    heading: "Resultados Consistentes em um Clique",
    subtitle: "Robôs de alta performance",
  },

  cta: {
    title: "Compre tempo. Ganhe Liberdade! ",
    subtitle: "Assine agora nossas estratégias. ",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Marrua",
    col1: [
      "Marrua é um touro que não aceita ser domesticado, que foge do rebanho.",
      "Desde o início de nossa trajetória buscamos ser diferentes dos demais. Encontramos na estratégia quantitativa o modelo ideal para nossos produtos ",
      "Nossos robôs são frutos da experiência de dois gestores de mercado aliada a juventude de uma equipe ávida por inovação e novos conhecimentos. ",
    ],
    col2: [""],
  },

  stats: {
    title: "Números que falam",
    subtitle: "Somos uma Gestora Quant",
    data: [
      {
        value: "2",
        description: "Gestores CGA",
      },
      {
        value: "+15",
        description: "Anos de mercado",
      },
      {
        value: "+6",
        description: "Clubes sob gestão utilizando robôs",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Marrua?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.calendar,
        title: "Free lunch",
        description: "30 dias para testar",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Excelência",
        description: "Equipe formada nas melhores Universidades do País",
      },
      {
        icon: iconsSet.ads_click,
        title: "Sem Vieses",
        description: "Nossos algoritmos não têm intervenção humana. Opere com razão, deixe a emoção para amadores",
      },
      {
        icon: iconsSet.editParams,
        title: "Adaptabilidade",
        description: "Estratégias em constante aprendizado. Algoritmos que aprendem e se renovam diariamente",
      },
      {
        icon: iconsSet.hourglass,
        title: "Tempo Livre",
        description: "Mais liberdade para aproveitar sua vida",
      },
      {
        icon: iconsSet.yoga,
        title: "Paz de Espírito",
        description: "Os robôs abrem e fecham operações durante o dia. Esqueça os mercados no overnight",
      },
    ],
  },

  testimonials: [
    {
      text: "Conseguiram aliar a experiência de mercado as mais novas tendências tecnológicas e gerar estratégias bem consistentes",
      author: "Rafael Rodrigues",
      job: "Programador",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Amo day trade, mas entendi que os vieses emocionais me prejudicavam demais e ao utilizar os robôs, ganhei tempo livre, sem perder a chance de ganhar dinheiro dia a dia ",
      author: "Rodolfo Napolitano",
      job: "Engenheiro Civil",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Marrua",
  },
};
